import { formatURIComponent } from "./utils"

export default (instance:string) => {

    const makeUrl = (path:string) => {
        return `/browser2?file_path=${formatURIComponent(path, instance)}&menu_key=specialTown&instance=${instance}`
    }

    return [{
        pageLayout: 'tabs',
        slogan: '',
        pageTitle: '特色小镇',
        pageTitleIcon: '',
        background_img: '',
        description: `在特色小镇规划建设中，华美专注于打造集文化、旅游、康养于一体的可持续生态项目。当前许多小镇存在定位模糊、业态单一、游客停留时间短等痛点，难以形成品牌效应和消费闭环。华美重点挖掘在地文化IP价值，设计沉浸式体验场景，助力小镇实现从单一观光向复合型度假目的地的转型升级。`,
        icons: [
            {
                name: '特色小镇',
                img: '/icons/成功案例.svg',
                background: 'black',
                url: makeUrl('/内容文件/华美/华美简介/20.特色小镇.pdf'),
                path: "四库赋能-酒店+/特色小镇/特色小镇"
            },
            {
                name: '华美项目',
                img: '/icons/成功案例.svg',
                background: 'black',
                url: makeUrl('华美项目'),
                path: "四库赋能-酒店+/特色小镇/华美项目"
            },
            {
                name: '数据赋能',
                img: '/icons/案例库.svg',
                background: 'black',
                url: makeUrl('/内容文件/四库赋能-酒店plus/特色小镇/数据赋能'),
                path: "四库赋能-酒店+/特色小镇/数据赋能"
            },
            {
                name: '全球案例',
                img: '/icons/案例库.svg',
                url: makeUrl('/内容文件/四库赋能-酒店plus/特色小镇/全球案例/全球案例（特色小镇）.xlsx'),
                background: 'black',
                path: "四库赋能-酒店+/特色小镇/全球案例"
            },
            {
                name: '预警问题',
                img: '/icons/工具库.svg',
                url: makeUrl('/内容文件/四库赋能-酒店plus/特色小镇/预警问题/预警问题（特色小镇）.xlsx'),
                background: 'black',
                path: "四库赋能-酒店+/特色小镇/预警问题"
            }
        ]
    }]
}